















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OversizedCheck extends Vue {
  @Prop() public value: boolean = false;

  public $refs!: {
    // modalOversized: OversizedVehicleModal;
  };

  public openModal() {
    //  this.$refs.modalOversized.open();
  }

  public onChange() {
    this.$emit('onChange', this.value);
  }
}
